<div class="modal fade" [config]="{backdrop: 'static', keyboard: false}" bsModal #allowanceWarningModal="bs-modal"
    tabindex="-1" role="dialog">
    <div class="modal-dialog modal-dialog-centered allowance-warning-modal" *ngIf="active">
        <div class="modal-content">
            <div class="modal-body p-4">
                <div class="text-center">
                    <div class="allowance-warning-icon mx-auto mb-3">
                        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none"
                            stroke="#e1342c" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M12 2l8 4v6c0 5-3.5 9.4-8 10-4.5-.6-8-5-8-10V6l8-4z" />
                            <line x1="12" y1="8" x2="12" y2="13" />
                            <circle cx="12" cy="16.5" r="1" fill="#e1342c" stroke="none" />
                        </svg>
                    </div>

                    <h4 class="allowance-warning-title mb-2">
                        Reduce {{ active.currencySymbol || 'token' }} allowance!
                    </h4>
                    <p class="allowance-warning-subtitle mb-3">
                        Your current allowance is
                        <span class="emphasis">{{ active.allowanceAmount | number:'1.2-2' }} {{ active.currencySymbol || 'token' }}</span>
                        higher than needed. We recommend
                        <span class="emphasis">lowering</span> your {{ active.currencySymbol || 'token' }} allowance.
                    </p>

                    <div class="allowance-warning-info-banner d-flex align-items-start text-start mb-4">
                        <svg class="me-2 flex-shrink-0 mt-1" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                            viewBox="0 0 24 24" fill="none" stroke="#e1342c" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round">
                            <circle cx="12" cy="12" r="10" />
                            <line x1="12" y1="16" x2="12" y2="12" />
                            <line x1="12" y1="8" x2="12.01" y2="8" />
                        </svg>
                        <span>{{ 'This is needed for better security and to protect your wallet from risks.' | walletLabel }}</span>
                    </div>

                    <div class="allowance-warning-actions">
                        <button type="button" class="allowance-warning-cancel" (click)="onCancel()"
                            [disabled]="processing">
                            Cancel.
                        </button>
                        <button type="button" class="allowance-warning-confirm" (click)="onConfirm()"
                            [disabled]="processing">
                            <span *ngIf="!processing">Reduce allowance.</span>
                            <span *ngIf="processing">Processing...</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
